import App from 'app';
import {
  HandleLettersOldPage,
  AddHandleLettersOldPage,
  ThuHoiXuLyDonOldPage,
  HandleLettersPage,
  AddHandleLettersPage,
  ThuHoiXuLyDonPage,
  GiaiQuyetDonPage,
  TongHopDonTreHanXuLy,
  TongHopDonTreHanGiaiQuyet,
  TongHopKetQuaGQDTCPage,
  TongHopKetQuaTiepCongDanPage,
  TongHopKetQuaGQDKNPage,
  TongHopKetQuaXuLyDonPage,
  TongHopKetQuaThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraDatDaiPage,
  TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage,
  TongHopKetQuaThanhTraXayDungCoBanPage,
  TongHopKetQuaThanhTraTaiChinhNganSachPage,
  TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage,
  TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage,
  CanBoNhanKetQuaKiemTraDeXuatPage,
  KetQuaCanBoNhanKetQuaKiemTraDeXuatPage,
  DanhSachThanhTraPage,
  DanhSachThanhTraDaPheDuyetPage,
  DanhSachCuocThanhTraPage,
  DanhSachDoiTuongTrungPage,
  ThemMoiCuocThanhTraPage,
  ChiTietCuocThanhTraPage,
  ChinhSuaCuocThanhTraPage,
  TinhHinhXuLyDonTaiDonViPage,
  ThongKeGiamSatNhapDonCuPage,
  DanhSachDonPage,
  DanhSachDonTheoKyPage,
  ChinhSuaCuocThanhTraDotXuatPage,
  ThayTheCuocThanhTraPage,
  TuGiaiQuyetDonPage,
  TruongPhongThuHoiPage,
  BoSungThongTinPage,
  BoSungThongTinLanhDaoPage,
  BoSungChuyenDonPage,
  ChiTietCuocThanhTraKeHoachPage,
  DanhSachTheoDoiThucHienPage,
  XuLyTheoDoiThucHienPage,
  KetQuaXuLyTheoDoiThucHienPage,
  DanhMucCuocThanhTraTrungPage,
  DanhMucTongHopThanhTraPage,
  DanhSachThongKeGiamSatDonCuPage,
  KetQuaKiemTraChiTietDoanhNghiepPage,
  KetQuaKiemTraTheoKeHoachDoanhNghiepPage,
  KetQuaKiemTraDotXuatDoanhNghiepPage,
  TongHopKetQuaThanhTraPage,
  TongHopKetQuaThanhTraThamNhungPage
} from 'pages';
import Parameter from 'modules/category/Parameter.jsx';
import TuDongBaoCao from 'modules/category/TuDongBaoCao.jsx';
import CauHinhKHTT from 'modules/category/CauHinhKHTT.jsx';
import Process from 'modules/category/Process.jsx';
import CongDanTraCuu from 'modules/tra-cuu/CongDanTraCuu.jsx';
import KetQuaCongDanTraCuu from 'modules/tra-cuu/KetQuaCongDanTraCuu.jsx';
import GiamSatTraCuu from 'modules/tra-cuu/GiamSatTraCuu.jsx';
import { Home, Page403, Help } from 'modules/home';
import { Statistical } from 'modules/thong-ke';
import ChangePassword from 'modules/change-password';
import ForgotPassword from 'modules/forgot-password';
import ResetPassword from 'modules/reset-password';
import CanBoTraCuu from 'modules/tra-cuu/CanBoTraCuu.jsx';
import ChiTietTraCuu from 'modules/tra-cuu/ChiTietTraCuu.jsx';
import BaoCaoDinhKy from 'modules/bao-cao-dinh-ky';
import BaoCaoTongHop from 'modules/bao-cao-tong-hop';
import LapBaoCaoTongHop from 'modules/bao-cao-tong-hop/LapBaoCaoTongHop.jsx';
import ChiTietDoiTuongTrung from 'modules/thanh-tra/ChiTietDoiTuongTrung.jsx';
import ThemMoiKeHoachThanhTra from 'modules/thanh-tra/ThemMoiKeHoachThanhTra.jsx';
import BaoCaoDinhKyChiTiet from 'modules/bao-cao-dinh-ky/BaoCaoDinhKyChiTiet.jsx';
import DanhSachDonViBCTH from 'modules/bao-cao-tong-hop/DanhSachDonViBCTH.jsx';
import DanhSachBaoCaoBCTH from 'modules/bao-cao-tong-hop/DanhSachBaoCaoBCTH.jsx';
import ChiTietDonViBCTH from 'modules/bao-cao-tong-hop/ChiTietDonViBCTH.jsx';
import ChiTietBaoCaoTaiDonVi from 'modules/bao-cao-tong-hop/ChiTietBaoCaoTaiDonVi.jsx';
import LapBaoCaoDinhKy from 'modules/bao-cao-dinh-ky/LapBaoCaoDinhKy.jsx';
import AutoLogin from 'modules/login/AutoLogin.jsx';
import ThongTinChiTietCuocThanhTra from 'modules/thanh-tra-trung/ThongTinChiTietCuocThanhTra.jsx';
import KeHoachThanhTraDetails from 'modules/thanh-tra-trung/KeHoachThanhTraDetails.jsx';
import NotificationDetails from 'modules/thanh-tra-trung/NotificationDetails.jsx';
import LoadingThongBao from 'modules/thanh-tra-trung/LoadingThongBao.jsx';
import DanhSachThongBao from 'modules/thanh-tra-trung/DanhSachThongBao.jsx';
import DanhSachQuanLyHoSo from 'modules/quan-ly-ho-so/DanhSachQuanLyHoSo.jsx';
import ChiTietQuanLyHoSo from 'modules/quan-ly-ho-so/ChiTietQuanLyHoSo.jsx';
import TheLoaiVanBan from 'modules/quan-ly-van-ban/TheLoaiVanBan.jsx';
import LinhVucVanBan from 'modules/quan-ly-van-ban/LinhVucVanBan.jsx';
import CoQuanBanHanhVanBan from 'modules/quan-ly-van-ban/CoQuanBanHanhVanBan.jsx';
import NhomHoSo from 'modules/quan-ly-ho-so/NhomHoSo.jsx';
import DanhMucVanBan from 'modules/quan-ly-van-ban/DanhMucVanBan.jsx';
import ThemMoiVanBan from 'modules/quan-ly-van-ban/ThemMoiVanBan.jsx';
import {
  ListReception,
  AddReception,
  DetailReception
} from 'modules/reception';
import {
  ThamQuyen,
  HuongDanSuDung,
  LoaiTaiLieu,
  DoiTuongThanhTra,
  NhomDoiTuongThanhTra,
  Organization,
  OrganizationLevel,
  CapDonViHanhChinh,
  Position,
  QuocTich,
  Role,
  Administrative,
  CongChuc,
  DanToc,
  Letters,
  TypeOfOrganizationLevel,
  DonViNgoai,
  LinhVucDoiTuongThanhTra,
  CapNhatNguoiDung,
  DanhSachDonTheoCongChuc,
  DanhSachDonTheoDonVi,
  Video,
  DanhMucVideo
} from 'modules/category';
import { ReceptionPeriodical, AddReceptionPeriodical, DetailReceptionPeriodical, DanhSachYeuCau } from 'modules/reception-periodical';
import { ReceptionUnexpectedly } from 'modules/reception-unexpectedly';
//DetailReceptionUnexpectedly
import { HandleLettersDetails } from 'modules/handle-letters';
import { HandleLettersOldDetails } from 'modules/handle-letters-old';
import Login from "modules/login";
import { XuLyGiaiQuyetDon } from "modules/giai-quyet-don";
import { TheoDoiThucHienGQD } from "modules/theo-doi-thuc-hien";
import { DonDaGiaiQuyet } from "modules/don-da-giai-quyet";
import DanhSachLichSuXuLyTTT from 'modules/thanh-tra-trung/DanhSachLichSuXuLyTTT.jsx'
import XuLyThanhTraTrung from 'modules/thanh-tra-trung/XuLyThanhTraTrung.jsx';
import ChiTietNoiDungXuLy from 'modules/thanh-tra-trung/ChiTietNoiDungXuLy.jsx'
import DanhSachTongHopKHTT from 'modules/thanh-tra-trung/DanhSachTongHopKHTT.jsx'
import LoginSSO from 'modules/login-sso';
// import KetQuaKiemTraChiTietDoanhNghiepPage from '../components/pages/thong-ke-bao-cao/KetQuaKiemTraChiTietDoanhNghiep';


export default function routes({ dispatch }) {
  return [{
    path: "/",
    component: App,
    indexRoute: {
      component: Home,
      name: 'home'
    },
    childRoutes: [{
      path: '/tiep-cong-dan',
      name: 'tiepcongdan',
      component: ListReception
    }, {
      path: '/tong-hop/don-tre-han-xu-ly-tai-don-vi',
      name: 'dontrehanxulytaidonvi',
      component: TongHopDonTreHanXuLy
    }, {
      path: '/tong-hop/don-tre-han-giai-quyet-tai-don-vi',
      name: 'dontrehangiaiquyettaidonvi',
      component: TongHopDonTreHanGiaiQuyet
    }, {
      path: '/tong-hop/don-tre-han-xu-ly-tai-dia-ban',
      name: 'dontrehanxulytaidiaban',
      component: TongHopDonTreHanGiaiQuyet
    }, {
      path: '/tong-hop/don-tre-han-giai-quyet-tai-dia-ban',
      name: 'dontrehangiaiquyettaidiaban',
      component: TongHopDonTreHanGiaiQuyet
    }, {
      path: '/tiep-cong-dan/thuong-xuyen/:type(/:id)',
      name: 'tiepcongdan',
      type: 'thuongXuyen',
      component: AddReception
    }, {
      path: '/tiep-cong-dan/chi-tiet-don/:id',
      name: 'tiepcongdan',
      component: DetailReception
    }, {
      path: '/quan-ly-danh-muc/tham-quyen',
      name: 'danhmuc',
      component: ThamQuyen
    },
    {
      path: '/quan-ly-danh-muc/huong-dan-su-dung',
      name: 'danhmuc',
      component: HuongDanSuDung
    },
    {
      path: '/quan-ly-danh-muc/loai-tai-lieu',
      name: 'danhmuc',
      component: LoaiTaiLieu
    }, {
      path: '/quan-ly-danh-muc/cap-co-quan',
      component: OrganizationLevel,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/co-quan',
      component: Organization,
      name: 'danhmuc',
      type: 'co-quan'
    }, {
      path: '/quan-ly-danh-muc/thanh-tra-trung-uong',
      component: Organization,
      name: 'danhmuc',
      type: 'trung-uong'
    }, {
      path: '/quan-ly-danh-muc/cap-hanh-chinh',
      component: CapDonViHanhChinh,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/chuc-vu',
      component: Position,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/quoc-tich',
      component: QuocTich,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/dan-toc',
      component: DanToc,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/don-thu',
      component: Letters,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/vai-tro',
      component: Role,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/hanh-chinh',
      component: Administrative,
      name: 'danhmuc'
    }, {
      path: '/quan-ly-danh-muc/cong-chuc',
      name: 'danhmuc',
      component: CongChuc
    }, {
      path: '/quan-ly-danh-muc/danh-muc-video',
      name: 'danhmuc',
      component: DanhMucVideo
    }, {
      path: '/quan-ly-danh-muc/video',
      name: 'danhmuc',
      component: Video
    }, {
      path: '/quan-ly-danh-muc/linh-vuc-doi-tuong-thanh-tra',
      name: 'danhmuc',
      component: LinhVucDoiTuongThanhTra
    }, {
      path: '/quan-ly-danh-muc/don-vi-ngoai-he-thong',
      name: 'danhmuc',
      component: DonViNgoai
    }, {
      path: '/quan-ly-danh-muc/doi-tuong-thanh-tra',
      name: 'danhmuc',
      component: DoiTuongThanhTra
    }, {
      path: 'quan-ly-danh-muc/nhom-doi-tuong-thanh-tra',
      name: 'danhmuc',
      component: NhomDoiTuongThanhTra
    }, {
      path: '/quan-ly-danh-muc/tham-so',
      name: 'danhmuc',
      component: Parameter
    }, {
      path: '/quan-ly-danh-muc/tu-dong-bao-cao',
      name: 'danhmuc',
      component: TuDongBaoCao
    }, {
      path: '/quan-ly-danh-muc/quan-ly-quy-trinh',
      name: 'danhmuc',
      component: Process
    }, {
      // Cấu hình kế hoạch thanh tra
      path: '/quan-ly-danh-muc/cau-hinh-ke-hoach-thanh-tra',
      name: 'danhmuc',
      component: CauHinhKHTT
    }, {
      path: '/quan-ly-danh-muc/loai-cap-co-quan',
      name: 'danhmuc',
      component: TypeOfOrganizationLevel
    }, {
      path: '/quan-ly-danh-muc/cap-nhat-nguoi-dung',
      name: 'danhmuc',
      component: CapNhatNguoiDung
    }, {
      path: '/quan-ly-danh-muc/danh-sach-don-theo-cong-chuc',
      name: 'danhmuc',
      component: DanhSachDonTheoCongChuc
    }, {
      path: '/quan-ly-danh-muc/danh-sach-don-theo-don-vi',
      name: 'danhmuc',
      component: DanhSachDonTheoDonVi
    }, {
      path: '/tiep-cong-dan/dinh-ky',
      name: 'tiepcongdan',
      component: ReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/danh-sach-yeu-cau',
      name: 'tiepcongdan',
      component: DanhSachYeuCau
    }, {
      path: '/tiep-cong-dan/dinh-ky/them-moi',
      name: 'tiepcongdan',
      component: AddReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/dinh-ky/chi-tiet/:id',
      name: 'tiepcongdan',
      type: 'dinhKy',
      component: DetailReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/lanh-dao/:type(/:id)',
      name: 'tiepcongdan',
      type: 'lanhDao',
      component: AddReception
    }, {
      path: '/tiep-cong-dan/dot-xuat',
      name: 'tiepcongdan',
      component: ReceptionUnexpectedly
    }, {
      path: '/tiep-cong-dan/dot-xuat/chi-tiet/:id',
      name: 'tiepcongdan',
      type: 'dotXuat',
      component: DetailReceptionPeriodical
    }, {
      path: '/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/:id',
      name: 'tiepcongdan',
      component: CanBoNhanKetQuaKiemTraDeXuatPage
    }, {
      path: '/tiep-cong-dan/ket-qua-kiem-tra-de-xuat/hoan-thanh/:id',
      name: 'tiepcongdan',
      component: KetQuaCanBoNhanKetQuaKiemTraDeXuatPage
    }, {
      path: '/xu-ly-don-cu',
      name: 'xulydoncu',
      component: HandleLettersOldPage
    }, {
      path: '/chi-tiet-don-cu/:id',
      name: 'xulydoncu',
      component: HandleLettersOldDetails
    }, {
      path: 'thu-hoi-xu-ly-don-cu/:typePage/:trangThaiDon/:id',
      name: 'xulydoncu',
      component: ThuHoiXuLyDonOldPage
    }, {
      path: '/xu-ly-don-cu/:type(/:id)',
      component: AddHandleLettersOldPage,
      name: 'xulydoncu'
    }, {
      path: '/xu-ly-don',
      name: 'xulydon',
      component: HandleLettersPage
    }, {
      path: '/chi-tiet-xu-ly-don/:typePage/:trangThaiDon/:id',
      name: 'xulydon',
      component: HandleLettersDetails
    }, {
      path: 'thu-hoi-xu-ly-don/:typePage/:trangThaiDon/:id',
      name: 'xulydon',
      component: ThuHoiXuLyDonPage
    }, {
      path: '/xu-ly-don/:type(/:id)',
      component: AddHandleLettersPage,
      name: 'xulydon'
    }, {
      path: '/dang-nhap',
      type: 'NORMAL',
      component: Login
    }, {
      path: '/login',
      type: 'NORMAL',
      component: LoginSSO
    }, {
      path: '/dang-nhap-sso',
      type: 'SSO',
      component: Login
    }, {
      path: '/sso-error',
      type: 'SSOERR',
      component: Login
    }, {
      path: '/quen-mat-khau',
      component: ForgotPassword
    }, {
      path: '/tao-mat-khau-moi/:code',
      component: ResetPassword
    }, {
      path: '/thay-doi-mat-khau',
      name: 'setting',
      component: ChangePassword
    }, {
      path: '/giai-quyet-don',
      component: GiaiQuyetDonPage,
      name: 'giaiquyet'
    }, {
      path: '/giai-quyet-don/:type/:id',
      name: 'giaiquyet',
      component: XuLyGiaiQuyetDon
    }, {
      path: '/tpth-giai-quyet-don/:type/:id',
      name: 'giaiquyet',
      component: TruongPhongThuHoiPage
    }, {
      path: '/tu-giai-quyet-don/:id',
      name: 'giaiquyet',
      component: TuGiaiQuyetDonPage
    },
    // Thong ke bao cao
    {
      path: '/thong-ke-bao-cao/tong-hop-gqd-to-cao',
      name: 'thongkebaocao',
      component: TongHopKetQuaGQDTCPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-tiep-cong-dan',
      name: 'thongkebaocao',
      component: TongHopKetQuaTiepCongDanPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-gqd-khieu-nai',
      name: 'thongkebaocao',
      component: TongHopKetQuaGQDKNPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-xu-ly-don',
      name: 'thongkebaocao',
      component: TongHopKetQuaXuLyDonPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-hanh-chinh',
      name: 'thongkebaocao',
      component: TongHopKetQuaThanhTraHanhChinhPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-xay-dung-co-ban',
      name: 'thongkebaocao',
      component: TongHopKetQuaThanhTraXayDungCoBanPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-tai-chinh',
      name: 'thongkebaocao',
      component: TongHopKetQuaThanhTraTaiChinhNganSachPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-thanh-tra-dat-dai',
      name: 'thongkebaocao',
      component: TongHopKetQuaThanhTraDatDaiPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-ket-luan-thanh-tra-hanh-chinh',
      name: 'thongkebaocao',
      component: TongHopKetQuaThucHienKetLuanThanhTraHanhChinhPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-quyet-dinh-xu-phat-qua-thanh-tra-kiem-tra-chuyen-nganh',
      name: 'thongkebaocao',
      component: TongHopKetQuaQuyetDinhXuPhatThanhTraKiemTraChuyenNganhPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh',
      name: 'thongkebaocao',
      component: TongHopBaoCaoKetQuaThanhTraKiemTraChuyenNganhPage
    }, {
      path: '/thong-ke-bao-cao/kiem-tra-chi-tiet-doanh-nghiep',
      name: 'thongkebaocao',
      component: KetQuaKiemTraChiTietDoanhNghiepPage
    }, {
      path: '/thong-ke-bao-cao/kiem-tra-theo-ke-hoach-doanh-nghiep',
      name: 'thongkebaocao',
      component: KetQuaKiemTraTheoKeHoachDoanhNghiepPage
    }, {
      path: '/thong-ke-bao-cao/kiem-tra-dot-xuat-doanh-nghiep',
      name: 'thongkebaocao',
      component: KetQuaKiemTraDotXuatDoanhNghiepPage
    }, {
      path: '/thong-ke-bao-cao/tong-hop-ket-qua-thanh-tra',
      name: 'thongkebaocao',
      component: TongHopKetQuaThanhTraPage
    }, {
      path: '/bao-cao-tham-nhung',
      name: 'baocaothamnhung',
      component: TongHopKetQuaThanhTraThamNhungPage
    }, {
      path: '/thong-ke-bao-cao/bao-cao-dinh-ky',
      name: 'thongkebaocao',
      component: BaoCaoDinhKy
    }, {
      path: '/thong-ke-bao-cao/bao-cao-dinh-ky-chi-tiet/:id',
      name: 'thongkebaocao',
      component: BaoCaoDinhKyChiTiet
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop',
      name: 'thongkebaocao',
      component: BaoCaoTongHop
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-don-vi/:id',
      name: 'thongkebaocao',
      component: DanhSachDonViBCTH
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop/danh-sach-bao-cao/:id',
      name: 'thongkebaocao',
      component: DanhSachBaoCaoBCTH
    }, {
      path: '/thong-ke-bao-cao/bao-cao-tong-hop/chi-tiet-don-vi/:id',
      name: 'thongkebaocao',
      component: ChiTietDonViBCTH
    }, {
      path: '/chi-tiet-bao-cao-tong-hop-cua-don-vi/:id',
      name: 'thongkebaocao',
      component: ChiTietBaoCaoTaiDonVi
    }, {
      path: '/thong-ke-bao-cao/lap-bao-cao-tong-hop/:id',
      name: 'thongkebaocao',
      component: LapBaoCaoTongHop
    }, {
      path: '/thong-ke-bao-cao/lap-bao-cao-dinh-ky/:id',
      name: 'thongkebaocao',
      component: LapBaoCaoDinhKy
    }, {
      path: '/thanh-tra',
      name: 'thanhtra',
      component: DanhSachThanhTraPage
    }, {
      path: '/thanh-tra/them-moi-ke-hoach-thanh-tra',
      name: 'thanhtra',
      type: 'new',
      component: ThemMoiKeHoachThanhTra
    },
    {
      path: '/thanh-tra/them-moi-ke-hoach-bo-sung/:id',
      name: 'thanhtra',
      type: 'old',
      component: ThemMoiKeHoachThanhTra
    }, {
      path: '/thanh-tra/chinh-sua-ke-hoach/:id',
      name: 'thanhtra',
      type: 'edit',
      component: ThemMoiKeHoachThanhTra
    },
    {
      path: '/thanh-tra/them-moi-ke-hoach-kiem-tra',
      name: 'thanhtra',
      type: 'new',
      component: ThemMoiKeHoachThanhTra
    },
    {
      path: '/thanh-tra/danh-sach-cuoc-thanh-tra',
      name: 'thanhtra',
      component: DanhSachCuocThanhTraPage
    }, {
      path: '/thanh-tra/danh-sach-doi-tuong-trung',
      name: 'thanhtra',
      component: DanhSachDoiTuongTrungPage
    }, {
      path: '/thanh-tra/chi-tiet-ke-hoach/:id',
      name: 'thanhtra',
      readonly: false,
      component: ChiTietDoiTuongTrung
    }, {
      path: '/thanh-tra/chi-tiet-ke-hoach-trung/:id',
      name: 'thanhtra',
      readonly: true,
      component: ChiTietDoiTuongTrung
    }, {
      path: '/thanh-tra/them-moi-cuoc-thanh-tra',
      name: 'thanhtra',
      component: ThemMoiCuocThanhTraPage
    }, {
      path: '/thanh-tra/them-moi-cuoc-kiem-tra',
      name: 'thanhtra',
      component: ThemMoiCuocThanhTraPage
    }, {
      path: '/thanh-tra/chi-tiet-cuoc-thanh-tra/:id',
      name: 'thanhtra',
      component: ChiTietCuocThanhTraPage
    }, {
      path: '/thanh-tra/chi-tiet-cuoc-thanh-tra-ke-hoach/:id',
      name: 'thanhtra',
      component: ChiTietCuocThanhTraKeHoachPage
    }, {
      path: '/thanh-tra/chinh-sua-cuoc-thanh-tra/:id',
      name: 'thanhtra',
      component: ChinhSuaCuocThanhTraPage
    }, {
      path: '/thanh-tra/chinh-sua-cuoc-thanh-tra-dot-xuat/:id',
      name: 'thanhtra',
      component: ChinhSuaCuocThanhTraDotXuatPage
    }, {
      path: '/thanh-tra/thay-the-cuoc-thanh-tra/:id',
      name: 'thanhtra',
      component: ThayTheCuocThanhTraPage
    }, {
      path: '/thanh-tra-da-phe-duyet',
      name: 'thanhtra',
      component: DanhSachThanhTraDaPheDuyetPage
    }, {
      path: '/thanh-tra/chi-tiet-ke-hoach-da-phe-duyet/:id',
      name: 'thanhtra',
      readonly: false,
      component: ChiTietDoiTuongTrung
    }, {
      path: '/thanh-tra/dieu-chinh-ke-hoach-da-phe-duyet/:id',
      name: 'thanhtra',
      type: 'edit',
      component: ThemMoiKeHoachThanhTra
    },

    //Theo doi giam sat
    {
      path: '/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi',
      name: 'theodoi',
      component: TinhHinhXuLyDonTaiDonViPage
    }, {
      path: '/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi/:id',
      name: 'theodoi',
      component: TinhHinhXuLyDonTaiDonViPage
    }, {
      path: '/theo-doi-giam-sat/danh-sach-don/:id',
      name: 'theodoi',
      component: DanhSachDonPage
    }, {
      path: '/theo-doi-giam-sat/danh-sach-don-theo-ky',
      name: 'theodoi',
      component: DanhSachDonTheoKyPage
    }, {
      path: '/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu',
      name: 'theodoi',
      component: ThongKeGiamSatNhapDonCuPage
    }, {
      path: '/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu/:id',
      name: 'theodoi',
      component: ThongKeGiamSatNhapDonCuPage
    }, {
      path: '/theo-doi-giam-sat/danh-sach-thong-ke-giam-sat-don-cu/:idDonVi/:tenDonVi(/:loaiThongTinDon)',
      name: 'theodoi',
      component: DanhSachThongKeGiamSatDonCuPage
    },
    // Theo dõi thực hiện
    {
      path: '/danh-sach-theo-doi-thuc-hien',
      name: 'theodoi',
      component: DanhSachTheoDoiThucHienPage
    }, {
      path: '/theo-doi-thuc-hien/xu-ly/:id',
      name: 'theodoi',
      component: XuLyTheoDoiThucHienPage
    }, {
      path: '/theo-doi-thuc-hien/chi-tiet/:id',
      name: 'theodoi',
      component: KetQuaXuLyTheoDoiThucHienPage
    },
    //end
    {
      path: 'bo-sung-thong-tin-giai-quyet-don/:id',
      name: 'theodoi',
      component: BoSungThongTinPage
    }, {
      path: 'bo-sung-thong-tin-xu-ly-don/:id',
      name: 'xulydon',
      component: BoSungThongTinLanhDaoPage
    }, {
      path: 'bo-sung-thong-tin-chuyen-don/:id',
      name: 'chuyenxulydon',
      component: BoSungChuyenDonPage
    }, {
      path: '/cong-dan-tra-cuu',
      name: 'congDanTraCuu',
      component: CongDanTraCuu
    }, {
      path: '/ket-qua-cong-dan-tra-cuu/:keySearch',
      name: 'congDanTraCuu',
      type: 'ketQua',
      component: KetQuaCongDanTraCuu
    }, {
      path: '/giam-sat-tra-cuu',
      name: 'giamSatTraCuu',
      type: 'ketQua',
      component: GiamSatTraCuu
    }, {
      path: '/can-bo-tra-cuu',
      name: 'canBoTraCuu',
      component: CanBoTraCuu
    }, {
      path: '/chi-tiet-tra-cuu/:maDon',
      name: 'chiTietTraCuu',
      component: ChiTietTraCuu
    }, {
      path: '/theo-doi-thuc-hien-giai-quyet-don',
      name: 'theodoi',
      component: TheoDoiThucHienGQD
    }, {
      path: '/tu-giai-quyet-theo-doi-thuc-hien/:id',
      name: 'theodoi',
      component: TuGiaiQuyetDonPage
    }, {
      path: '/theo-doi-thuc-hien-giai-quyet-don/:type/:id',
      name: 'theodoi',
      component: XuLyGiaiQuyetDon
    }, {
      path: '/theo-doi-thuc-hien-xu-ly-don/:typePage/:trangThaiDon/:id',
      name: 'theodoi',
      component: HandleLettersDetails
    }, {
      path: '/don-da-giai-quyet',
      name: 'dagiaiquyet',
      component: DonDaGiaiQuyet
    }, {
      path: '/don-da-giai-quyet/:type/:id',
      name: 'dagiaiquyet',
      component: XuLyGiaiQuyetDon
    }, {
      path: '/page-403',
      name: 'page403',
      component: Page403
    }, {
      path: '/huong-dan-su-dung',
      name: 'help',
      component: Help
    },
    // Thanh tra trùng
    {
      path: 'thanh-tra/danh-muc-cuoc-thanh-tra-trung',
      name: 'thanhtratrung',
      component: DanhMucCuocThanhTraTrungPage
    }, {
      path: 'thanh-tra/danh-muc-tong-hop-thanh-tra-cua-cac-don-vi',
      name: 'thanhtratrung',
      type: 'donvi',
      component: DanhMucTongHopThanhTraPage
    }, {
      path: 'thanh-tra/danh-sach-cuoc-thanh-tra-tai-tp',
      name: 'thanhtratrung',
      type: 'thanhpho',
      component: DanhMucTongHopThanhTraPage
    }, {
      path: 'thanh-tra/danh-muc-cuoc-thanh-tra-trung/xu-ly',
      type: 'xuly',
      name: 'thanhtratrung',
      component: XuLyThanhTraTrung
    }, {
      path: 'thanh-tra/danh-muc-cuoc-thanh-tra-trung/tiep-tuc-xu-ly',
      type: 'tieptucxuly',
      name: 'thanhtratrung',
      component: XuLyThanhTraTrung
    }, {
      path: 'thanh-tra/cuoc-thanh-tra/chi-tiet/:id',
      type: 'thanhtra',
      name: 'thanhtra',
      component: ThongTinChiTietCuocThanhTra
    }, {
      path: 'thanh-tra/cuoc-thanh-tra-trung/chi-tiet/:id',
      type: 'thanhtratrung',
      name: 'thanhtra',
      component: ThongTinChiTietCuocThanhTra
    }, {
      path: 'thanh-tra/ke-hoach-thanh-tra/chi-tiet/:id',
      name: 'thanhtra',
      component: KeHoachThanhTraDetails
    }, {
      path: 'thanh-tra/noi-dung-xu-ly/chi-tiet/:id',
      name: 'thanhtra',
      component: ChiTietNoiDungXuLy
    }, {
      path: 'thanh-tra/danh-sach-tong-hop-khtt-cua-cac-don-vi',
      name: 'thanhtra',
      component: DanhSachTongHopKHTT
    }, {
      path: 'thanh-tra/danh-sach-lich-su-ttt',
      name: 'thanhtratrung',
      component: DanhSachLichSuXuLyTTT
    }, {
      path: 'thanh-tra/chi-tiet-thong-bao/:id',
      name: 'thanhtra',
      component: NotificationDetails
    }, {
      path: 'thanh-tra/danh-sach-thong-bao',
      name: 'thanhtra',
      component: DanhSachThongBao
    }, {
      path: 'thanh-tra/thong-bao-loading/:id',
      name: 'thanhtra',
      component: LoadingThongBao
    }, {
      path: '/quan-ly-ho-so/danh-sach-ho-so',
      name: 'quanlyhoso',
      component: DanhSachQuanLyHoSo
    },
    {
      path: '/quan-ly-ho-so/danh-sach-ho-so/:id',
      name: 'quanlyhoso',
      component: ChiTietQuanLyHoSo
    },
    {
      path: '/quan-ly-ho-so/danh-muc-nhom-ho-so',
      name: 'quanlyhoso',
      component: NhomHoSo
    },
    {
      path: '/quan-ly-van-ban/the-loai-van-ban',
      name: 'quanlyvanban',
      component: TheLoaiVanBan
    },
    {
      path: '/quan-ly-van-ban/linh-vuc-van-ban',
      name: 'linhvucvanban',
      component: LinhVucVanBan
    },
    {
      path: '/quan-ly-van-ban/co-quan-ban-hanh-van-ban',
      name: 'coquanbanhanh',
      component: CoQuanBanHanhVanBan
    },
    {
      path: '/quan-ly-van-ban/danh-sach-van-ban',
      name: 'danhsachvanban',
      component: DanhMucVanBan
    },
    {
      path: 'quan-ly-van-ban/danh-sach-van-ban/them-moi',
      name: 'danhsachvanban',
      component: ThemMoiVanBan
    },
    {
      path: 'quan-ly-van-ban/danh-sach-van-ban/chinh-sua/:id',
      name: 'danhsachvanban',
      component: ThemMoiVanBan
    },
    {
      path: '/thong-ke',
      name: 'thongke',
      component: Statistical
    }
    ]
  }, {
    path: "/redirect",
    component: AutoLogin
  }];
}



// WEBPACK FOOTER //
// ./src/routes/routes.js